module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/anchor-left-up-5f020af7eab87ee97723dd760bcb5bc9.svg";